var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('portal',{attrs:{"to":"v-main"}}),_c('v-card-text',{staticClass:"pa-0",staticStyle:{"height":"300px","overflow":"auto"}},[_c('a-table-f-api',{ref:"table",attrs:{"api":_vm.api,"model":_vm.modelList,"searchable":false,"defaults":{
        filters: _vm.filter,
        sort: { key: 'id', order: 'DESC' },
        paramName: 'tabContract',
      }},on:{"click":function($event){return _vm.onClickRow($event)}}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }